module.exports = __webpack_public_path__ + "static/media/rank-icon.1a2ede60.png";